import { render, staticRenderFns } from "./StockCmrForm.vue?vue&type=template&id=4f5ca24f&scoped=true"
import script from "./StockCmrForm.vue?vue&type=script&lang=js"
export * from "./StockCmrForm.vue?vue&type=script&lang=js"
import style0 from "./StockCmrForm.vue?vue&type=style&index=0&id=4f5ca24f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ca24f",
  null
  
)

export default component.exports